import React from "react";

export default function BrandLogo({ compact = false }) {
  return (
    <div className="flex items-center gap-3">
      <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-700 via-brand-600 to-accent-500 text-base font-extrabold text-white shadow-brand sm:h-12 sm:w-12 sm:text-lg">
       TK
      </div>

      {!compact ? (
        <div className="min-w-0">
          <div className="truncate text-base font-bold text-white-800 sm:text-lg">
            نظام إدارة الأعمال 
          </div>
          <div className="truncate text-[11px] text-slate-500 sm:text-xs">
            دخل • مصاريف • مشاريع • مواعيد
          </div>
        </div>
      ) : null}
    </div>
  );
}
